import { ParsedRecord } from '../../components/import/ImportParser';
import { SiteRapsCsvColumns } from '../../components/site-rap/constants';
import { IUpdateSiteRap } from './interface';

export function mapCsvImportSiteRapToCreateSiteRapDto(record: ParsedRecord<SiteRapsCsvColumns>) {
    const dto = {} as IUpdateSiteRap;

    dto.site_id = record['Site ID*'].parsedValue;

    dto.participation_type = record['Participation Type'].parsedValue;
    dto.reduction_type = record['Reduction Type'].parsedValue;
    dto.primary_load_type = record['Primary Load Type'].parsedValue;
    dto.curtailment_strategy = record['Curtailment Strategy'].parsedValue;
    dto.reduction_action_plan = record['Reduction Action Plan'].parsedValue;

    return dto;
}
